var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable complexity */
/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { ButtonBase } from '@material-ui/core';
import * as S from './styles';
export var Button = forwardRef(function Button(props, ref) {
    var as = props.as, onClick = props.onClick, children = props.children, className = props.className, style = props.style, fullWidth = props.fullWidth, variant = props.variant, disabled = props.disabled, loading = props.loading, hovered = props.hovered, circular = props.circular, color = props.color, size = props.size, type = props.type, icon = props.icon, iconPosition = props.iconPosition, stopPropagation = props.stopPropagation, preventDefault = props.preventDefault, rest = __rest(props, ["as", "onClick", "children", "className", "style", "fullWidth", "variant", "disabled", "loading", "hovered", "circular", "color", "size", "type", "icon", "iconPosition", "stopPropagation", "preventDefault"]);
    var fullWidthClassName = fullWidth ? 'full-width' : false;
    var disabledClassName = disabled ? 'disabled' : false;
    var circularClassName = circular ? 'circular' : false;
    var hoveredClassName = hovered ? 'hovered' : false;
    var hasIconClassName = icon || loading ? 'has-icon' : false;
    var loadingIconClassName = loading ? 'is-loading' : false;
    var iconPositionClassName = iconPosition + "-icon-position";
    var variantClassName = variant + "-variant";
    var colorClassName = color + "-color";
    var sizeClassName = size + "-size";
    var rootClass = cx(className, colorClassName, sizeClassName, fullWidthClassName, hasIconClassName, iconPositionClassName, circularClassName, disabledClassName, variantClassName, hoveredClassName, loadingIconClassName);
    var iconClass = cx(sizeClassName, iconPositionClassName, loadingIconClassName);
    var handleOnClick = function (e) {
        stopPropagation && e.stopPropagation();
        preventDefault && e.preventDefault();
        onClick && onClick(e);
    };
    var renderAs = as === 'button' ? ButtonBase : as;
    return (React.createElement(S.Button, __assign({ as: renderAs, type: type, className: rootClass, style: style, onClick: handleOnClick, ref: ref, disabled: disabled }, rest),
        (icon || loading) && React.createElement(S.Icon, { className: iconClass }, loading ? React.createElement("div", { className: 'spinner' }) : icon),
        children));
});
Button.defaultProps = {
    as: 'button',
    color: 'black',
    fullWidth: true,
    disabled: false,
    circular: false,
    loading: false,
    hovered: false,
    variant: 'primary',
    size: 'medium',
    iconPosition: 'left',
    type: 'button'
};
Button.displayName = 'Button';
export default Button;
//# sourceMappingURL=Button.js.map